import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'sc-field-dynamic',
  templateUrl: './field-dynamic.component.html',
  styleUrls: ['./field-dynamic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldDynamicComponent extends FieldType implements OnInit {
  public selectedType$: Observable<string>;
  public ngOnInit(): void {
    this.selectedType$ = this.to.selectedType.pipe(
      filter(type => this.field.type !== type),
      tap((type: string) => {
        // this.formControl.setValue(null);
        this.field.type = type;
        if (type === 'radio' || type === 'toggle' || type === 'checkbox' || type === 'datetime') {
          this.field.wrappers = [];
        } else {
          this.field.wrappers = [...[], 'form-field'];
          this.field.templateOptions.hideFieldUnderline = false;
        }
      })
    );
  }
}
